<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم بارگذاری گواهی نامه</h5>

      <br>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">  تعداد گواهی بارگذاری شده <b>ماه جاری</b> </p>
                  <h4>{{current_Year}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">تعداد گواهی بارگذاری شده <b>ماه گذشته</b></p>
                  <h4>{{last_Month}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-certificate highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">تعداد گواهی بارگذاری شده <b>سال جاری</b> </p>
                  <h4>{{current_Month}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>


      <button type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-warning" style="margin-left: 5px;"> جستجوی مشتری  <i class="fa fa-vcard"></i> </button>

      <div *ngIf="Data_Seleted_Customer.id>0">
          <form  >
            <br/>
            <br/>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">کد مشتری  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">نام مشتری بهفا  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
              </div>
            </div>
          </form>

          <button  type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration)" class="btn btn-danger" style="margin-left: 5px;"> جستجوی کارشناس کالیبراسیون   <i class="fa fa-user-circle-o"></i> </button>
          <form *ngIf="Data_Seleted_ExpertCalibration.id>0" >
            <br/>
            <br/>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1"> نام  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.name}}" />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">نام خانوادگی  </label>
                <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.familly}}" />
              </div>
            </div>
            <div *ngIf="Data_Seleted_Certificate.length==0">
              <div class="row">
                <div class="form-group col-md-12">
                    <label for="exampleInputEmail1"> انتخاب فایل </label>
                    <input #file  multiple type="file" class="form-control" >
                </div>
              </div>
              <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
              <button  *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-upload"></i> آپلود فایل </button>
            </div>
            <div *ngIf="Data_Seleted_Certificate.length!=0">
              <br/>
              <br/>
              <h3>اطلاعات گواهی نامه ها</h3>
              <br/>
              <br/>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">علت</label>
                  <select [(ngModel)]="FormUploader_elat" name="FormUploader_elat" class="custom-select" >
                    <option value="1">خراب</option>
                    <option value="2">نقض لوازم ضروری</option>
                    <option value="3">اعلام عدم انجام کار توسط مشتری</option>
                    <option value="4">سایر</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">تعداد برگشت تجهیزات</label>
                  <input [(ngModel)]="FormUploader_tedad_bargashti" name="FormUploader_tedad_bargashti" type="number" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                </div>
              </div>

              <div class="table-responsive">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #489b39; color: white;">
                    <tr>
                      <th>#</th>
                      <th>Certificate No</th>
                      <th>Calibration Date</th>
                      <th>Recal. Date</th>
                      <th>ID</th>
                      <th>امکانات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of Data_Seleted_Certificate">
                     <td>{{Data_Seleted_Certificate.indexOf(item)+1}}</td>
                      <td>{{item.certificate_no}}</td>
                      <td>{{item.calibration_date}}</td>
                      <td>{{item.recal_date}}</td>
                      <td>
                        <button type="button" (click)="openModal_Recipt(templateRecipt,Data_Seleted_Certificate.indexOf(item))" style="margin-left: 10px;" class="btn btn-danger"> جستجوی ID   </button>

                        <input disabled *ngIf="item.device_code" type="text" [value]="item.device_code" />
                      </td>
                      <td style="cursor: pointer;">
                        <a style="cursor: pointer;" (click)="Certificate_Delete(Data_Seleted_Certificate.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                      </td>

                    </tr>
                  </tbody>
                </table>
             </div>


              <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
              <button *ngIf="!InProccessing" (click)="openModal_FinishForm(templateFinishForm)" type="button"   class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
            </div>

          </form>
      </div>

  </div>
</div>

<ng-template #templateCustomer>
  <div class="modal-header">
     <h4 class="modal-title pull-left">لیست اطلاعات مشتری  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1">نام مشتری  </label>
            <input  type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"  [(ngModel)]="Search_CodeName_Customer_Table"  placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: Customerpage,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRecipt>
  <div class="modal-header">
     <h4 class="modal-title pull-left">لیست اطلاعات تجهیزات  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Recipt.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">کد دستگاه</label>
          <input [(ngModel)]="Filter_Device_Code" (keyup)="Change_Filter_Device_Code()" name="Filter_Device_Code" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام دستگاه</label>
          <input [(ngModel)]="Filter_Device_Name" (keyup)="Change_Filter_Device_Code()" name="Filter_Device_Name" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>نام دستگاه</th>
              <th>کد دستگاه</th>
              <th>سریال دستگاه</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Calibration
            |filter:Filter_Device_Code:'device_code'
            |filter:Filter_Device_Name:'device_name'
            | paginate
                    : {
                        id: 'DataList_Recipt',
                        itemsPerPage: 20,
                        currentPage: Calibrationpage,
                        totalItems: (
                          DataList_Calibration
                          |filter:Filter_Device_Code:'device_code'
                          |filter:Filter_Device_Name:'device_name'
                          ).length
                      }">
              <td>{{DataList_Calibration.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.device_code}} </td>
              <td>{{item.device_serial}} </td>
              <td (click)="Set_Selected_Calibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Recipt" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_Recipt" type="button" (click)="Read_Calibration()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Recipt.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibration>
  <div class="modal-header">
     <h4 class="modal-title pull-left">لیست کارشناس کالیبراسیون  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام خانوادگی</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
             <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateFinishForm>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> تایید ثبت نهایی اطلاهات  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FinishForm.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <p>آیا شما از تعداد گواهی نامه آپلود شده ، مطمئین هستید؟</p>
  </div>
  <div class="modal-footer">
    <button (click)="SubmitCertificate()" type="button" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus"></i> تایید و نهایی ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_FinishForm.hide()">بستن</button>
  </div>
</ng-template>
